import React, { useState, useEffect } from 'react'

import { useTranslation } from 'react-i18next'

import ErrorModal from '../error-modal/error-modal'

import { useEndpointStatusData, useEndpointStatusActions } from '../../store/endpointStatus'

const showErrorModal = (fireErrorModal, errorMessage, t, searchParams, allowedCountries, languageGSD) => {
  switch (errorMessage?.type) {
    case 'InvalidPaymentRequestExceptionDetail':
      fireErrorModal(
        t('payment.errors.invalidPaymentRequestExceptionTitle'),
        t('payment.errors.invalidPaymentRequestException')
      )
      break
  }
}

const PaymentErrorModalHandler = () => {
  const { t } = useTranslation()

  const errorMessage = useEndpointStatusData.errorMessage()
  const { setEndpointStatus } = useEndpointStatusActions()

  const [modalFail, setModalFail] = useState(false)
  const [errorModalMessage, setErrorModalMessage] = useState()
  const [errorModalTitle, setErrorModalTitle] = useState()
  const [errorModalHref, setErrorModalHref] = useState(null)

  const fireErrorModal = (title, message, href = null) => {
    setErrorModalHref(href)
    setErrorModalTitle(title)
    setErrorModalMessage(message)
    setModalFail(true)
  }

  useEffect(() => {
    showErrorModal(
      fireErrorModal,
      errorMessage,
      t
    )
  }, [errorMessage])

  return (
    <ErrorModal
      isOpen={modalFail}
      toggleModalFail={() => setModalFail((prevState) => !prevState)}
      title={errorModalTitle}
      message={errorModalMessage}
      href={errorModalHref}
      clearErrorState={() => { setEndpointStatus('errorMessage') }}
    />
  )
}

export default PaymentErrorModalHandler
